import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import { Link } from "react-router-dom";
import { BaseAppContext } from "../utils/context";
import { useContext } from "react";
import { UserRole } from "../models/enums/UserRoleEnum";

function TemporaryDrawer() {
  const [open, setOpen] = React.useState(false);
  const { loggedUserRole } = useContext(BaseAppContext);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const menuItems = [
    // { text: "Home", path: "/" },
    { text: "Dashboard", path: "/dashboard" },
  ];

  if (loggedUserRole === UserRole.Doctor) {
    menuItems.push(
      { text: "Patients List", path: "/patients" },
      { text: "Booking", path: "/booking" }
    );
  }

  if (loggedUserRole === UserRole.Patient) {
    menuItems.push(
      { text: "Book an Appointment", path: "/appointment" },
      { text: "Track Bookings", path: "/track-bookings" },
      { text: "Emergency", path: "/emergency" }
    );
  }

  const settingsItems = [
    { text: "Profile", path: "/profile" },
    { text: "Settings", path: "/settings" },
    { text: "LogOut", path: "/logout" },
  ];

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {menuItems.map(({ text, path }, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={path}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {settingsItems.map(({ text, path }, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={path}>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <>
      <Button
        sx={{ position: "absolute", left: 0 }}
        onClick={toggleDrawer(true)}
      >
        ☰
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </>
  );
}

function NavBar() {
  const { isLoggedIn, loggedUserRole } = useContext(BaseAppContext);
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container">
        {/* Drawer Menu Button */}
        {isLoggedIn && <TemporaryDrawer />}

        {/* Brand */}
        <a className="navbar-brand fw-bold ms-3" href="/">
          Dr. Sachin Harekare
        </a>

        {/* Toggle button for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Nav links */}
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="services">
                Services
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="gallery">
                Gallery
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="about">
                About
              </a>
            </li>
            {!isLoggedIn && (
              <li className="nav-item">
                <a className="nav-link" href="login">
                  Login
                </a>
              </li>
            )}
            {loggedUserRole !== UserRole.Doctor && (
              <li className="nav-item">
                <a className="btn btn-primary ms-lg-3" href="appointment">
                  Book an Appointment
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
